<template>
  <div style="width: 100vw">
    <v-layout
      row
      wrap
      style="
        font-weight: bold !important;
        font-family: 'Aleo' !important;
        font-size: 20pt !important;
        color: white;
        background: #4cc7e8;
      "
      class="mb-0"
    >
      <v-flex xm12 sm6 style="text-align: center">
        <h3
          class="counterTextHome"
          style="
            font-weight: bold !important;
            font-family: 'Aleo' !important;
            font-size: 3rem !important;
            color: white;
          "
        >
          <v-icon
            style="font-size: 3rem; top: -5px; position: relative"
            color="red"
            >mdi-charity</v-icon
          >{{ totalEstimatedCC }}
        </h3>
        <h3
          class="counterTextHome"
          style="
            font-family: 'Aleo' !important;
            font-size: 1.5rem !important;
            color: white;
            margin: auto;
            max-width: 300px;
            top: -20px;
            position: relative;
          "
        >
          Potential Estimated Upstream Contributions Possible:
        </h3>
      </v-flex>
      <v-flex xm12 sm6 style="text-align: center">
        <h3
          class="counterTextHome"
          style="
            font-weight: bold !important;
            font-family: 'Aleo' !important;
            font-size: 3rem !important;
            color: white;
          "
        >
          <v-icon
            style="font-size: 3rem; top: -5px; position: relative"
            color="red"
            >mdi-charity</v-icon
          >{{ totalEqvHrs }}Hrs
        </h3>
        <h3
          class="counterTextHome"
          style="
            font-family: 'Aleo' !important;
            font-size: 1.5rem !important;
            color: white;
            margin: auto;
            max-width: 300px;
            top: -20px;
            position: relative;
          "
        >
          Potential Equivalent Hours of Generated Community Work:
        </h3>
      </v-flex>
      <!-- <v-flex xs12 sm6 style="text-align: center" class="py-0">
        <div style="max-width: 500px; margin: auto"></div>

        <span style="color: #ed2224"></span>
      </v-flex>
      <v-flex xs12 sm6 style="text-align: center" class="py-0">
        <div style="max-width: 500px; margin: auto"></div>
        <span style="color: #ed2224"></span>
      </v-flex> -->
    </v-layout>

    <v-layout row wrap align-center class="py-2" style="background: #e6e7e8">
      <v-flex md1></v-flex>
      <v-flex
        xs11
        md6
        class="mb-0 pb-0 pt-2"
        style="
          text-align: left;
          position: relative;
          position: relative;
          margin: auto;
        "
      >
        <p
          style="
            font-weight: bold !important;
            font-family: 'Aleo' !important;
            font-size: 30pt !important;
            color: #58595b;
          "
          class="mb-0"
        >
          Instructions
        </p>
        <p
          style="color: #58595b; position: relative; margin: auto"
          class="pb-4"
        >
          <span style="font-weight: bold">Step 1)</span> Please explore the
          options we believe could create impact through your purchasing. <br />
          <span style="font-weight: bold">Step 2)</span> Select what response
          best suits this opportunity, and help us indicate by writing some
          specific comments.<br />
          <span style="font-weight: bold">Step 3)</span> We will work with you
          to action options you see as relevant.
        </p>
      </v-flex>
      <v-flex xs12 md5 v-if="!$vuetify.breakpoint.smAndDown">
        <!-- <v-img
          :src="require('../../assets/Values/UpstreamNZ Badges-05.png')"
          class="joinOptionCards mr-4"
          style="height: 150px; width: 150px; float: right"
          contain
        /> -->
      </v-flex>
    </v-layout>

    <v-container class="pt-0" fill-height grid-list-xl>
      <v-layout justify-center wrap>
        <v-container grid-list-xl class="pageContent">
          <v-layout row wrap>
            <v-flex class="px-0" style="text-align: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ma-0 mb-4"
                    v-if="hidden.interestedSelected"
                    color="success"
                    style="width: 277px"
                    dark
                    v-on="on"
                    @click="
                      hidden.interestedSelected = false;
                      filterLeads();
                    "
                  >
                    <v-icon>mdi-chevron-down</v-icon> Show&nbsp
                    <span style="color: #ed2024"> {{ hidden.interested }} </span
                    >&nbsp Interested Now
                  </v-btn>
                  <v-btn
                    @click="
                      hidden.interestedSelected = true;
                      filterLeads();
                    "
                    color="red"
                    style="width: 277px"
                    class="ma-0"
                    dark
                    v-else
                    v-on="on"
                  >
                    Hide Interested Now
                  </v-btn>
                </template>
                <span>Options that you have marked as being interested in</span>
              </v-tooltip>
            </v-flex>
            <v-flex class="px-0" style="text-align: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ma-0 mb-4"
                    v-if="hidden.futureFollowUpSelected"
                    color="success"
                    style="width: 277px"
                    dark
                    v-on="on"
                    @click="
                      hidden.futureFollowUpSelected = false;
                      filterLeads();
                    "
                  >
                    <v-icon>mdi-chevron-down</v-icon>Show &nbsp
                    <span style="color: #ed2024">{{
                      hidden.futureFollowUp
                    }}</span
                    >&nbsp Interested in Future
                  </v-btn>
                  <v-btn
                    @click="
                      hidden.futureFollowUpSelected = true;
                      filterLeads();
                    "
                    color="red"
                    style="width: 277px"
                    class="ma-0"
                    dark
                    v-else
                    v-on="on"
                  >
                    Hide Interested in Future
                  </v-btn>
                </template>
                <span
                  >Options that you have marked as "Ask me in the future"</span
                >
              </v-tooltip>
            </v-flex>
            <v-flex class="px-0" style="text-align: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ma-0 mb-4"
                    v-if="hidden.alreadyUsingSelected"
                    color="success"
                    style="width: 277px"
                    dark
                    v-on="on"
                    @click="
                      hidden.alreadyUsingSelected = false;
                      filterLeads();
                    "
                  >
                    <v-icon>mdi-chevron-down</v-icon>Show &nbsp<span
                      style="color: #ed2024"
                      >{{ hidden.alreadyUsing }}</span
                    >&nbsp Already Using
                  </v-btn>
                  <v-btn
                    @click="
                      hidden.alreadyUsingSelected = true;
                      filterLeads();
                    "
                    color="red"
                    style="width: 277px"
                    class="ma-0"
                    dark
                    v-else
                    v-on="on"
                  >
                    Hide Already Using
                  </v-btn>
                </template>
                <span>Options that you have marked as "Already Using"</span>
              </v-tooltip>
            </v-flex>
            <v-flex class="px-0" style="text-align: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ma-0 mb-4"
                    v-if="hidden.noOpportunitySelected"
                    color="success"
                    style="width: 277px"
                    dark
                    v-on="on"
                    @click="
                      hidden.noOpportunitySelected = false;
                      filterLeads();
                    "
                  >
                    <v-icon>mdi-chevron-down</v-icon>Show &nbsp
                    <span style="color: #ed2024">{{
                      hidden.noOpportunity
                    }}</span
                    >&nbsp Not Interested
                  </v-btn>
                  <v-btn
                    @click="
                      hidden.noOpportunitySelected = true;
                      filterLeads();
                    "
                    color="red"
                    style="width: 277px"
                    class="ma-0"
                    dark
                    v-else
                    v-on="on"
                  >
                    Hide Not Interested
                  </v-btn>
                </template>
                <span>Options that you have marked as "Not Interested"</span>
              </v-tooltip>
            </v-flex>

            <v-flex
              xs12
              style="
                text-align: left;
                font-weight: bold !important;
                font-family: 'Aleo' !important;
                font-size: 20pt !important;
                color: #58595b;
              "
            >
              Viewing Options:
              <span style="color: #4cc7e8">{{ selectedOptionsText }}</span>
            </v-flex>

            <v-flex
              class="mb-4"
              xs12
              v-for="(lead, index) in filteredLeads"
              :key="index"
            >
              <div>
                <v-layout
                  row
                  wrap
                  class="pa-3"
                  style="position: relative"
                  :class="{
                    SoundingPositive:
                      lead.customersResponse == 'Sounding Positive',
                    FutureFollowup:
                      lead.customersResponse == 'Future Follow Up',
                    NoOpportunity:
                      lead.customersResponse == 'No Opportunity' ||
                      lead.customersResponse ==
                        'No Opportunity (Already Using)',
                    NoStatus:
                      lead.customersResponse != 'No Opportunity' &&
                      lead.customersResponse != 'Future Follow Up' &&
                      lead.customersResponse != 'Sounding Positive' &&
                      lead.customersResponse !=
                        'No Opportunity (Already Using)',
                    FeaturedLead:
                      featuredLeadBool && $route.params.leadID == lead.id,
                  }"
                >
                  <v-flex xs12 sm4>
                    <span
                      style="
                        font-weight: bold;
                        top: -4px;
                        position: relative;
                        width: 19px;
                        margin-right: 10px;
                      "
                    >
                      Supplier Type:
                    </span>
                    <br />
                    <span style="font-size: 20pt">
                      {{ lead.listTitle }}
                    </span>
                    <br />
                    <span
                      style="
                        font-weight: bold;
                        top: -4px;
                        position: relative;
                        margin-right: 50px;
                      "
                    >
                      Supplier:
                    </span>
                    <br />
                    <span style="font-size: 20pt">
                      {{ lead.leadFor_name }}
                    </span>
                    <br />

                    <br />
                    <span
                      style="font-weight: bold; top: -2px; position: relative"
                      class="mt-1"
                    >
                      Specific benefits for you:
                    </span>
                    <br />
                    <span style="font-size: 16pt">{{ lead.leadSummary }}</span>
                  </v-flex>

                  <v-flex xs12 sm5 class="pb-0">
                    <!-- <input
                    type="text"
                    style="
                      width: 100%;
                      border: 1px solid #666666;
                      background: white;
                    "
                    v-model="lead.customerComments"
                  /> -->
                    <span
                      style="
                        font-weight: bold;
                        margin-right: 25px;
                        top: 0px;
                        position: relative;
                      "
                      class="mt-1"
                    >
                      Your Response
                    </span>
                    <v-radio-group
                      class="mt-0"
                      :row="!$vuetify.breakpoint.xs"
                      :column="$vuetify.breakpoint.xs"
                      @change="saveAll(lead.id)"
                      v-model="lead.customersResponse"
                    >
                      <v-radio
                        :label="`Interested Now`"
                        value="Sounding Positive"
                        color="black"
                      ></v-radio>
                      <v-radio
                        :label="`Interested in Future`"
                        value="Future Follow Up"
                        color="black"
                      ></v-radio>
                      <br v-if="!$vuetify.breakpoint.xs" />
                      <v-radio
                        :label="`Already Using`"
                        value="No Opportunity (Already Using)"
                        color="black"
                      ></v-radio>
                      <v-radio
                        :label="`Not Interested`"
                        value="No Opportunity"
                        color="black"
                      ></v-radio>
                    </v-radio-group>
                    <span
                      style="
                        font-weight: bold;
                        margin-right: 25px;
                        top: 0px;
                        position: relative;
                      "
                      class="mt-1"
                      v-if="lead.customersResponse != 'No Opportunity'"
                    >
                      What you're interested in
                    </span>
                    <v-textarea
                      rows="1"
                      v-if="lead.customersResponse != 'No Opportunity'"
                      @input="onCommentsChanged(lead.id)"
                      placeholder="e.g: I'd be interested in getting a quote for this"
                      v-model="lead.customersComments"
                    ></v-textarea>
                    <span style="font-weight: bold; position: relative">
                      <v-icon color="red">mdi-charity</v-icon> Est.
                      Contribution:
                    </span>
                    <span style="font-size: 20pt; color: red">
                      {{ getEstCC(lead.estCC) }}
                    </span>
                    <br />
                    <span style="font-weight: bold; position: relative">
                      <v-icon color="red">mdi-charity</v-icon> Eqv. Hours of
                      Impact:
                    </span>
                    <span style="font-size: 20pt; color: red">
                      {{ calculateCommunityHours(lead.estCC) }}
                    </span>
                  </v-flex>
                  <v-flex
                    xs12
                    sm3
                    style="text-align: right; position: relative"
                    class="mb-4 pb-0"
                    :class="{
                      leadCardLargPaddingBottom: $vuetify.breakpoint.mdAndDown,
                    }"
                  >
                    <v-img :src="lead.imageUrl"> </v-img>
                    <v-btn
                      block
                      color="#4cc7e8"
                      @click="openBusiness(lead)"
                      dark
                    >
                      View Supplier Profile
                    </v-btn>
                    <v-btn
                      block
                      color="success"
                      class="mr-0"
                      v-if="containsStatus(lead) && hideHiddenLeads"
                      @click="hideLead(lead)"
                    >
                      Save & Hide Option
                    </v-btn>

                    <span
                      style="
                        position: absolute;
                        bottom: -30px;
                        right: 0px;
                        width: 188px;
                        color: gray;
                      "
                      >{{ index + 1 }} of {{ filteredLeads.length }}</span
                    >
                  </v-flex>
                </v-layout>
              </div>
              <v-divider style="background: #e6e7e8"></v-divider>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { StripeElements } from "vue-stripe-checkout";
import moment from "moment";

export default {
  props: ["leadData"],
  components: {
    StripeElements,
  },
  watch: {
    leadData: function () {
      this.filterLeads();
      this.calculateOverallStats();
    },
  },
  data: () => ({
    customersChoiceRadioButton: {},
    customerComments: {},
    filteredLeads: [],
    leadsHidden: 0,
    hidden: {
      interestedSelected: true,
      interested: 0,
      futureFollowUpSelected: true,
      futureFollowUp: 0,
      noOpportunitySelected: true,
      noOpportunity: 0,
      alreadyUsingSelected: true,
      alreadyUsing: 0,
    },
    hideHiddenLeads: true,
    searchDebounce: null,
    estCCList: [
      {
        id: "1",
        value: 100,
        desc: "< $100",
      },
      {
        id: "2",
        value: 200,
        desc: "$100 - $200",
      },
      {
        id: "3",
        value: 500,
        desc: "$200 - $500",
      },
      {
        id: "4",
        value: 1000,
        desc: "$500 - $1,000",
      },
      {
        id: "5",
        value: 1000,
        desc: "$1,000 +",
      },
    ],
    totalEstimatedCC: 0,
    totalEqvHrs: 0,
    featuredLeadBool: false,
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
    }),
    selectedOptionsText: function () {
      let text = "";

      if (!this.hidden.interestedSelected) {
        text += "Interested Now";
      }

      if (!this.hidden.futureFollowUpSelected) {
        text += text == "" ? "Interested in Future" : ", Interested in Future";
      }

      if (!this.hidden.alreadyUsingSelected) {
        text += text == "" ? "Already Using" : ", Already Using";
      }

      if (!this.hidden.noOpportunitySelected) {
        text += text == "" ? "Not Interested" : ", Not Interested";
      }

      return text == "" ? "With no responses yet" : text;
    },
  },
  mounted() {
    this.filterLeads();
    this.calculateOverallStats();
  },
  methods: {
    onCommentsChanged(id) {
      clearTimeout(this.searchDebounce);

      this.searchDebounce = setTimeout(() => {
        this.saveAll(id);
      }, 1000);
    },
    containsStatus(lead) {
      if (
        lead.customersResponse == "No Opportunity" ||
        lead.customersResponse == "No Opportunity (Already Using)" ||
        lead.customersResponse == "Future Follow Up" ||
        lead.customersResponse == "Sounding Positive"
      ) {
        return true;
      } else {
        return false;
      }
    },
    hideLead(lead) {
      let ltc = this.leadData.find((l) => l.id == lead.id);
      if (ltc) {
        ltc.customerHidden = "1";
      }
      this.filterLeads();
      this.saveAll();
    },
    filterLeads() {
      this.hidden.interested = 0;
      this.hidden.futureFollowUp = 0;
      this.hidden.noOpportunity = 0;
      this.hidden.alreadyUsing = 0;
      this.featuredLeadBool = this.$route.params.hasOwnProperty("leadID");

      this.filteredLeads = this.leadData.filter((l) => {
        let passed = 0;

        if (this.featuredLeadBool && l.id == this.$route.params.leadID) {
          return true;
        }

        //Interested Selected
        if (l.customersResponse == "Sounding Positive") {
          this.hidden.interested += 1;
          if (this.hidden.interestedSelected != true) {
            return true;
          }
        } else if (this.hidden.interestedSelected == true) {
          passed += 1;
        }

        //No Opportunity Selected
        if (l.customersResponse == "No Opportunity") {
          this.hidden.noOpportunity += 1;
          if (this.hidden.noOpportunitySelected != true) {
            return true;
          }
        } else if (this.hidden.noOpportunitySelected == true) {
          passed += 1;
        }

        //Future Follow Up Selected
        if (l.customersResponse == "Future Follow Up") {
          this.hidden.futureFollowUp += 1;
          if (this.hidden.futureFollowUpSelected != true) {
            return true;
          }
        } else if (this.hidden.futureFollowUpSelected == true) {
          passed += 1;
        }

        //Already Using Selected
        if (l.customersResponse == "No Opportunity (Already Using)") {
          this.hidden.alreadyUsing += 1;
          if (this.hidden.alreadyUsingSelected != true) {
            return true;
          }
        } else if (this.hidden.alreadyUsingSelected == true) {
          passed += 1;
        }

        if (passed == 4) {
          return true;
        }
      });

      // Bring Featured listing to the front
      if (this.featuredLeadBool) {
        let leadID = this.$route.params.leadID;
        this.filteredLeads.sort(function (x, y) {
          return x.id == leadID ? -1 : y.id == leadID ? 1 : 0;
        });
      }

      this.leadsHidden = this.leadData.length - this.filteredLeads.length;
    },
    saveAll(id = null) {
      let payload = {
        linkKey: this.$route.params.linkKey,
        changedID: id,
        leads: this.leadData,
      };
      this.$store.dispatch("linkKey/saveAllLeads", payload);
    },

    openBusiness(lead) {
      window.open(
        `https://www.upstream.co.nz/business/${lead.leadFor_business_id}`,
        "_blank"
      );
    },
    getEstCC(cc) {
      if (cc != "") {
        return this.estCCList.find((e) => e.id == cc).desc;
      } else {
        return "$0.00";
      }
    },
    calculateCommunityHours(cc) {
      if (cc != "") {
        return (
          this.calculateCommunityHrs(
            this.estCCList.find((e) => e.id == cc).value
          ) + "Hrs"
        );
      } else {
        return "0 Hrs";
      }
    },
    calculateOverallStats() {
      this.totalEstimatedCC = 0;
      this.totalEqvHrs = 0;
      let data = JSON.parse(JSON.stringify(this.leadData));
      if (data.length > 0) {
        data.forEach((cc) => {
          if (cc.estCC != "") {
            this.totalEstimatedCC += this.estCCList.find(
              (e) => e.id == cc.estCC
            ).value;
          } else {
            this.totalEstimatedCC += 0;
          }
          if (cc.estCC != "") {
            this.totalEqvHrs += this.calculateCommunityHrs(
              this.estCCList.find((e) => e.id == cc.estCC).value
            );
          } else {
            this.totalEqvHrs += 0;
          }
        });
      }

      let formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      this.totalEstimatedCC = formatter.format(this.totalEstimatedCC);
      this.totalEqvHrs = Math.round(this.totalEqvHrs);
    },
  },
};
</script>

<style scoped>
.SoundingPositive {
  color: black;
  background: #7acdbc;
}
.FutureFollowup {
  color: black;
  background-color: #81d7ef;
}
.NoOpportunity {
  color: black;
  background-color: #e6e7e8;
}
.blueBarButtonsFloatRight {
  position: absolute !important;
  right: 10px !important;
  top: 20px !important;
}
.FeaturedLead {
  border: 3px solid #4cc7e8;
  border-radius: 5px;
}
</style>
